/**
 * GIFTBOX v5.0 — Prestige 10
 * Sepet tutarı 3.000 TL ve üzeriyse Premium Gift Box otomatik ve ücretsiz eklenir
 * (fiyatı Shopify "Hediye Kutusu / Free Gift Box" Buy X Get Y indirimiyle 0 olur; indirim de 3.000 TL alım tutarına bağlı).
 * 3.000 TL altında upsell mesajı ("Sepetine X TL daha ekle") + ücretli (50 TL) "Sepete Ekle" seçeneği gösterilir.
 * Tutar 3.000 TL altına düşünce sadece OTOMATİK eklenen kutu çıkarılır; müşterinin kendi eklediği kutu kalır.
 * Ürün adedi / set sayımı artık kullanılmıyor.
 */
(() => {
  "use strict";

  const CONFIG = {
    GIFTBOX_PRODUCT_HANDLE: "hediye-kutusu",
    GIFTBOX_VARIANT_ID: 42030861975627,
    MIN_TOTAL_TRY: 300000, // kuruş cinsinden: 3.000 TL
    DEBUG: false,
    DEBOUNCE_DELAY: 250,
    WIDGET_ID: "giftbox-upsell-widget",
    ADDED_KEY: "giftbox_auto_added",
    DECLINED_KEY: "giftbox_declined",
  };

  const nativeFetch = window.fetch.bind(window);

  const LANG = (() => {
    const path = window.location.pathname;
    const htmlLang = document.documentElement.lang || "";
    if (/^\/en(\/|$)/.test(path) || htmlLang.startsWith("en")) return "en";
    if (/^\/it(\/|$)/.test(path) || htmlLang.startsWith("it")) return "it";
    return "tr";
  })();
  const NUMBER_LOCALE = { tr: "tr-TR", en: "en-GB", it: "it-IT" }[LANG] || "tr-TR";

  const I18N = {
    tr: {
      upsell: (amt) => `Sepetine ${amt} daha ekle, hediye kutusu bizden 🎁`,
      added: "Özel hediye kutunuz ücretsiz eklendi",
      declined: "Özel hediye kutunuz ücretsiz",
      inCart: "Hediye kutusu sepetinizde",
      addFree: "Ücretsiz Ekle",
      buy: "Sepete Ekle",
      remove: "Kaldır",
    },
    en: {
      upsell: (amt) => `Add ${amt} more to your cart, the gift box is on us 🎁`,
      added: "Your special gift box has been added for free",
      declined: "Your special gift box is free",
      inCart: "Gift box is in your cart",
      addFree: "Add for Free",
      buy: "Add to Cart",
      remove: "Remove",
    },
    it: {
      upsell: (amt) => `Aggiungi ancora ${amt} al carrello, la confezione regalo è un nostro omaggio 🎁`,
      added: "La tua confezione regalo è stata aggiunta gratuitamente",
      declined: "La tua confezione regalo è gratuita",
      inCart: "Confezione regalo nel carrello",
      addFree: "Aggiungi gratis",
      buy: "Aggiungi al carrello",
      remove: "Rimuovi",
    },
  };
  const t = I18N[LANG] || I18N.tr;
  const log = (...a) => CONFIG.DEBUG && console.log("[GiftBox]", ...a);

  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: (k) => { try { sessionStorage.removeItem(k); } catch (e) {} },
  };

  /* Para birimi: eşik TL, sepet ziyaretçinin para biriminde (EUR vb.) olabilir */
  const rate = () => {
    const r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  };
  const thresholdPresentment = () => Math.round(CONFIG.MIN_TOTAL_TRY * rate());
  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(NUMBER_LOCALE, { style: "currency", currency: currency || "TRY", maximumFractionDigits: 0 }).format(Math.ceil(cents / 100));
    } catch (e) {
      return Math.ceil(cents / 100) + " " + (currency || "TL");
    }
  };

  /* Ürün verisi (sadece widget gösterilecekse, bir kez) */
  let productData = null;
  const fetchProductData = async () => {
    if (productData) return productData;
    try {
      const prefix = LANG === "tr" ? "" : `/${LANG}`;
      const res = await nativeFetch(`${prefix}/products/${CONFIG.GIFTBOX_PRODUCT_HANDLE}.json`);
      if (!res.ok) return null;
      const { product } = await res.json();
      const variant = product.variants.find((v) => v.id === CONFIG.GIFTBOX_VARIANT_ID) || product.variants[0];
      const src = (variant.featured_image && variant.featured_image.src) || (product.images && product.images[0] && product.images[0].src) || "";
      productData = {
        title: product.title,
        price: variant.price,
        image: src ? src + (src.includes("?") ? "&" : "?") + "width=160" : "",
      };
      return productData;
    } catch (e) {
      return null;
    }
  };

  const formatPrice = (p) => {
    const n = parseFloat(p);
    if (!n) return "";
    return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "TL";
  };

  /* Sepet API (kendi isteklerimiz interceptor'a takılmasın diye nativeFetch) */
  const cartAPI = {
    async get() {
      const res = await nativeFetch("/cart.js", { credentials: "same-origin" });
      return res.json();
    },
    async add(auto) {
      const item = { id: CONFIG.GIFTBOX_VARIANT_ID, quantity: 1 };
      if (auto) item.properties = { _giftbox: "auto" };
      const res = await nativeFetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [item] }),
      });
      if (!res.ok) throw new Error(`add ${res.status}`);
    },
    async change(key, quantity) {
      const res = await nativeFetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error(`change ${res.status}`);
    },
  };

  const isGift = (i) => Number(i.variant_id) === CONFIG.GIFTBOX_VARIANT_ID;
  const eligibleLines = (cart) => cart.items.filter((i) => !isGift(i) && !i.gift_card);
  const eligibleTotal = (cart) => eligibleLines(cart).reduce((s, i) => s + i.final_line_price, 0);
  const giftLines = (cart) => cart.items.filter(isGift);
  const isAuto = (i) => i.properties && i.properties._giftbox;

  const refreshPrestigeCart = () => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  };

  /* Stil */
  const injectStyles = () => {
    if (document.getElementById("giftbox-styles")) return;
    const s = document.createElement("style");
    s.id = "giftbox-styles";
    s.textContent = `
      .giftbox-widget{border:1px solid rgba(0,0,0,.12);padding:14px 16px;margin:16px 0;display:flex;align-items:center;gap:14px;background:#fff}
      .giftbox-widget--in-drawer{margin:12px var(--drawer-padding,20px)}
      .giftbox-widget--added{background:#fafaf8}
      .giftbox-widget__image{width:64px;height:64px;object-fit:cover;flex-shrink:0}
      .giftbox-widget__content{flex:1;min-width:0}
      .giftbox-widget__title{font-size:12px;font-weight:500;letter-spacing:.06em;text-transform:uppercase;margin:0 0 4px;color:#1a1a1a;font-family:var(--heading-font-family,inherit)}
      .giftbox-widget__msg{font-size:13px;line-height:1.4;margin:0;color:#501414}
      .giftbox-widget__check{display:inline-flex;align-items:center;gap:6px;color:#2d7d46}
      .giftbox-widget__actions{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:8px}
      .giftbox-widget__btn{padding:8px 18px;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;border:none;cursor:pointer;background:#1a1a1a;color:#fff;min-height:34px}
      .giftbox-widget__btn:disabled{opacity:.5;cursor:not-allowed}
      .giftbox-widget__price{font-size:12px;color:#717171}
      .giftbox-widget__link{background:none;border:none;padding:0;font-size:12px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;color:#1a1a1a}
    `;
    document.head.appendChild(s);
  };

  /* Widget */
  const CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let lastGiftKey = null;
  let lastRemainingText = "";

  const widgetHTML = (state, isDrawer) => {
    const p = productData || { title: "Premium Gift Box", image: "", price: "" };
    const price = formatPrice(p.price);
    let body = "";
    if (state === "upsell") {
      body = `<p class="giftbox-widget__msg">${t.upsell(lastRemainingText)}</p>
        <div class="giftbox-widget__actions">
          <button type="button" class="giftbox-widget__btn" data-giftbox-action="buy">${t.buy}</button>
          ${price ? `<span class="giftbox-widget__price">${price}</span>` : ""}
        </div>`;
    }
    if (state === "incart") {
      body = `<p class="giftbox-widget__msg giftbox-widget__check">${CHECK_SVG}${t.inCart}</p>
        <div class="giftbox-widget__actions"><button type="button" class="giftbox-widget__link" data-giftbox-action="remove">${t.remove}</button></div>`;
    }
    if (state === "added") body = `<p class="giftbox-widget__msg giftbox-widget__check">${CHECK_SVG}${t.added}</p>`;
    if (state === "declined") {
      body = `<p class="giftbox-widget__msg">${t.declined}</p>
        <div class="giftbox-widget__actions"><button type="button" class="giftbox-widget__btn" data-giftbox-action="add-free">${t.addFree}</button></div>`;
    }
    return `<div class="giftbox-widget${isDrawer ? " giftbox-widget--in-drawer" : ""}${state === "added" || state === "incart" ? " giftbox-widget--added" : ""}" id="${CONFIG.WIDGET_ID}${isDrawer ? "-drawer" : "-page"}">
      ${p.image ? `<img class="giftbox-widget__image" src="${p.image}" alt="${p.title}" loading="lazy" width="64" height="64">` : ""}
      <div class="giftbox-widget__content"><p class="giftbox-widget__title">${p.title}</p>${body}</div>
    </div>`;
  };

  const removeWidgets = () => document.querySelectorAll(`[id^="${CONFIG.WIDGET_ID}"]`).forEach((el) => el.remove());

  const getDrawer = () => document.querySelector("cart-drawer, #cart-drawer, .cart-drawer");

  let lastState = null;

  const renderState = (state) => {
    lastState = state;
    removeWidgets();
    if (!state) return;
    injectStyles();

    const drawer = getDrawer();
    if (drawer) {
      const footer = drawer.querySelector('[slot="footer"], .cart-drawer__footer');
      const items = drawer.querySelector(".cart-drawer__items");
      const tmp = document.createElement("div");
      tmp.innerHTML = widgetHTML(state, true);
      if (footer) footer.parentNode.insertBefore(tmp.firstElementChild, footer);
      else if (items) items.after(tmp.firstElementChild);
    }

    const page = document.querySelector(".cart-page, .cart-content, [data-section-type='cart'], main .cart");
    if (page) {
      const footer = page.querySelector(".cart-page__footer, .cart__footer, .cart__ctas, [data-cart-footer]");
      const form = page.querySelector('form[action*="/cart"]');
      const tmp = document.createElement("div");
      tmp.innerHTML = widgetHTML(state, false);
      if (footer) footer.parentNode.insertBefore(tmp.firstElementChild, footer);
      else if (form) form.appendChild(tmp.firstElementChild);
    }
  };

  /* Ana senkronizasyon */
  let syncing = false;

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      let cart = await cartAPI.get();
      const total = eligibleTotal(cart);
      const threshold = thresholdPresentment();
      const hasItems = eligibleLines(cart).length > 0;
      const qualifies = total >= threshold;
      const lines = giftLines(cart);
      let changed = false;

      if (qualifies) {
        if (lines.length === 0) {
          if (store.get(CONFIG.ADDED_KEY) === "1") {
            store.set(CONFIG.DECLINED_KEY, "1"); // müşteri kutuyu kendisi çıkardı
          } else if (store.get(CONFIG.DECLINED_KEY) !== "1") {
            await cartAPI.add(true);
            store.set(CONFIG.ADDED_KEY, "1");
            changed = true;
          }
        } else {
          for (const l of lines) {
            if (isAuto(l) && l.quantity > 1) { await cartAPI.change(l.key, 1); changed = true; }
          }
          store.set(CONFIG.ADDED_KEY, "1");
        }
      } else {
        for (const l of lines) {
          if (isAuto(l)) { await cartAPI.change(l.key, 0); changed = true; }
        }
        store.del(CONFIG.ADDED_KEY);
        store.del(CONFIG.DECLINED_KEY);
      }

      if (changed) {
        cart = await cartAPI.get();
        refreshPrestigeCart();
      }

      const finalLines = giftLines(cart);
      const hasGift = finalLines.length > 0;
      lastGiftKey = hasGift ? finalLines[0].key : null;
      lastRemainingText = formatMoney(Math.max(threshold - total, 100), cart.currency);

      let state = null;
      if (qualifies) state = hasGift ? "added" : "declined";
      else if (hasItems) state = hasGift ? "incart" : "upsell";

      if (state) await fetchProductData();
      renderState(state);
      log("sync", { total, threshold, hasGift, state });
    } catch (e) {
      console.warn("[GiftBox] sync failed:", e);
    } finally {
      syncing = false;
    }
  };

  const debounce = (fn, d) => { let x; return () => { clearTimeout(x); x = setTimeout(fn, d); }; };
  const debouncedSync = debounce(sync, CONFIG.DEBOUNCE_DELAY);
  const debouncedRender = debounce(() => renderState(lastState), 120);

  /* Butonlar */
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-giftbox-action]");
    if (!btn) return;
    e.preventDefault();
    const action = btn.dataset.giftboxAction;
    btn.disabled = true;
    try {
      if (action === "add-free") {
        store.del(CONFIG.DECLINED_KEY);
        await cartAPI.add(true);
        store.set(CONFIG.ADDED_KEY, "1");
      } else if (action === "buy") {
        await cartAPI.add(false); // ücretli, müşterinin kendi seçimi — otomatik silinmez
      } else if (action === "remove" && lastGiftKey) {
        await cartAPI.change(lastGiftKey, 0);
      }
      refreshPrestigeCart();
      setTimeout(sync, 300);
    } catch (err) {
      console.warn("[GiftBox] action failed:", err);
      btn.disabled = false;
    }
  });

  /* Tetikleyiciler */
  const setupFetchInterceptor = () => {
    window.fetch = async function (...args) {
      const response = await nativeFetch(...args);
      try {
        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || String(args[0] || "");
        if (/\/cart\/(add|change|update|clear)/.test(url)) debouncedSync();
      } catch (e) {}
      return response;
    };
  };

  const observeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === "attributes" && m.attributeName === "open" && drawer.hasAttribute("open")) {
          debouncedSync();
          return;
        }
      }
      if (lastState && drawer.hasAttribute("open") && !drawer.querySelector(`[id^="${CONFIG.WIDGET_ID}"]`)) {
        debouncedRender();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ["open"], childList: true, subtree: true });
  };

  const init = () => {
    setupFetchInterceptor();
    ["variant:add", "line-item:change", "cart:change"].forEach((ev) => document.addEventListener(ev, debouncedSync));
    observeDrawer();
    if (/\/cart\/?$/.test(window.location.pathname)) sync();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.GiftBoxSystem = { sync, getConfig: () => CONFIG, setDebug: (v) => { CONFIG.DEBUG = v; } };
})();
